import { calculateStrategyAPY } from '@/domain/euler/shared/onchainHelpers'

export interface StrategyAPYData {
  shares: bigint
  interestRate: bigint
  totalBorrows: bigint
  totalAssets: bigint
  interestFee?: bigint // Optional interest fee from the strategy vault
}

/**
 * Calculates weighted average APY from strategy vault data
 * @param strategies Array of strategy data with shares, interest rate, borrows, assets, and optional interest fee
 * @returns Weighted average APY as a percentage
 */
export function calculateWeightedAPY(strategies: StrategyAPYData[]): number {
  let totalAllocationShares = 0n
  const strategyAPYs: { shares: bigint; apy: number }[] = []

  // Calculate APY for each strategy using shared helper
  for (const { shares, interestRate, totalBorrows, totalAssets, interestFee } of strategies) {
    if (totalAssets > 0n) {
      const strategyAPY = calculateStrategyAPY(interestRate, totalBorrows, totalAssets, interestFee)
      totalAllocationShares += shares
      strategyAPYs.push({ shares, apy: strategyAPY })
    }
  }

  // Calculate weighted average
  if (totalAllocationShares > 0n && strategyAPYs.length > 0) {
    let weightedAPY = 0
    for (const { shares, apy } of strategyAPYs) {
      const weight = Number(shares) / Number(totalAllocationShares)
      weightedAPY += apy * weight
    }
    return weightedAPY
  }

  return 0
}
